import React from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics';

import type { ContentTypesHeaderProps } from './ContentTypesHeader';
import { OBJECT_HEADER_SEGMENT_METRIC } from './perf.config';
import { ContentTypesHeaderLoader } from './ContentTypesHeaderLoader';

export const ContentTypesHeader = (props: ContentTypesHeaderProps) => (
	<>
		<PageSegmentLoadStart metric={OBJECT_HEADER_SEGMENT_METRIC} />
		<ContentTypesHeaderLoader {...props} />
	</>
);

export type { HeaderFeaturesType } from './ContentTypesHeaderFeatures';
export type { MainActions } from './content-types-actions/MainActions';
export type { MoreActions, Item } from './content-types-actions/MoreActions';
export type { ContentStatus } from './content-types-actions/ContentStatus/ContentStatus';
export type { ContentActions } from './ContentTypesHeader';
export { ContentStatusName } from './content-types-actions/ContentStatus/ContentStatus';
export { useIsEditorToolbarDockedAtTop } from './progressive-header/useIsEditorToolbarDockedAtTop';
